module.exports = __webpack_public_path__ + "static/media/locked-padlock.c9c9b9c2.svg";